import script from "./VoucherTplList.vue?vue&type=script&setup=true&lang=js"
export * from "./VoucherTplList.vue?vue&type=script&setup=true&lang=js"

import "./VoucherTplList.vue?vue&type=style&index=0&id=2ef1c70a&lang=less&scoped=true"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ef1c70a"]])

export default __exports__